/** Circular letter avatar with a deterministic colour derived from the seed. */
const PALETTE = [
  '#ff2d55',
  '#ff9500',
  '#34c759',
  '#5ac8fa',
  '#af52de',
  '#ff375f',
  '#0a84ff',
  '#ffd60a',
];

function colorFor(seed) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function AuthorAvatar({ letter, seed = '', size = 44 }) {
  const ch = (letter || seed || '?')[0].toUpperCase();
  return (
    <span
      class="avatarc"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: colorFor(seed || ch),
        fontSize: `${Math.round(size * 0.42)}px`,
      }}
      aria-hidden="true"
    >
      {ch}
    </span>
  );
}
